import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackServiceClick, trackServiceShowNew } from './tracking';
import { Carousel } from '../../components/Carousel';
import { Service } from '../../components/Service';
import { selectServices } from '../../selectors/services';

export const ServicesV3Container: React.FC = () => {
  const services = useSelector(selectServices);

  const onShow = React.useCallback(trackServiceShowNew, []);
  const onClick = React.useCallback((key: string) => trackServiceClick(key, true), []);

  if (!services.length) {
    return null;
  }

  return (
    <Carousel>
      {services.map(({ key, title, url, image }) => (
        <Service
          key={`service-${key}`}
          title={title}
          url={url}
          image={image}
          analyticsKey={key}
          onShow={onShow}
          onClick={onClick}
        />
      ))}
    </Carousel>
  );
};
